<template>
    <div class="home-dec">
        <p class="dec-title">红云智汇</p>
        <p class="dec-desc">领先的组工信息化解决方案专家</p>
    </div>
</template>

<script>
export default {
    name: 'HomeDec'
}
</script>

<style lang="less" >
.home-dec{
    width: 100%;
    height: 228px;
    background-image: url('@/assets/images/home-des.png');
    background-size: 100% 100%;
    text-align: center;
    padding-top: 50px;
    .dec-title{
        height: 54px;
        font-size: 54px;
        line-height: 1;
        color: rgba(244, 54, 8, 1);
        font-weight: 700;
        margin-bottom: 20px;

    }
    .dec-desc{
        height: 44px;
        line-height: 1;
        font-size: 44px;
        color: rgba(106, 106, 106, 1);
    }

}
</style>